import { useEffect, useState } from 'react';
import PageHeader from '@/components/PageHeader.jsx';
import { getAfipCredentialsStatus, saveAfipCredentials } from '@/services/afipCredentials.js';

export default function AfipCredentialsPage() {
  const [status, setStatus] = useState(null);
  const [certificateFile, setCertificateFile] = useState(null);
  const [privateKeyFile, setPrivateKeyFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const load = async () => {
    setLoading(true);
    try { setStatus(await getAfipCredentialsStatus()); } catch (loadError) { setError(loadError.message); } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const save = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setError(''); setMessage('');
    if (!certificateFile || !privateKeyFile) {
      setError('Adjuntá el certificado y su clave privada.');
      return;
    }
    setSaving(true);
    try {
      const nextStatus = await saveAfipCredentials({ certificateFile, privateKeyFile });
      setStatus(nextStatus); setCertificateFile(null); setPrivateKeyFile(null);
      form.reset();
      setMessage('Credenciales AFIP actualizadas. Las próximas autorizaciones usarán este certificado.');
    } catch (saveError) { setError(saveError.message); } finally { setSaving(false); }
  };

  return <div className="mx-auto flex w-full max-w-4xl flex-col gap-4 p-3">
    <PageHeader title="Certificados de factura electrónica" subtitle="Configurá las credenciales AFIP de este tenant." />
    <section className="rounded-2xl border border-[rgba(var(--border),.7)] bg-[rgba(var(--panel),.72)] p-5 shadow-sm">
      {loading ? <p className="text-sm text-[rgb(var(--muted))]">Cargando configuración…</p> : <>
        <div className="rounded-xl bg-[rgba(var(--subpanel),.65)] p-4 text-sm">
          <p className="font-semibold">{status?.configured ? 'Credenciales configuradas' : 'Sin credenciales configuradas'}</p>
          {status?.configured ? <p className="mt-1 text-[rgba(var(--muted),.95)]">Certificado: {status.certificateName || 'sin nombre'} · Clave: {status.privateKeyName || 'sin nombre'}</p> : <p className="mt-1 text-[rgba(var(--muted),.95)]">Para solicitar CAE este tenant necesita ambos archivos.</p>}
        </div>
        <form onSubmit={save} className="mt-5 grid gap-4">
          <Field label="Certificado emitido por AFIP"><input type="file" accept=".crt,.cer,.pem" onChange={(event) => setCertificateFile(event.target.files?.[0] || null)} /><span className="text-xs text-[rgba(var(--muted),.95)]">Archivo PEM: normalmente .crt o .pem.</span></Field>
          <Field label="Clave privada correspondiente"><input type="file" onChange={(event) => setPrivateKeyFile(event.target.files?.[0] || null)} /><span className="text-xs text-[rgba(var(--muted),.95)]">Archivo PEM: normalmente .key o .pem. No se muestra ni se puede descargar luego.</span></Field>
          {status && !status.encryptionReady ? <p className="text-sm text-red-600">Falta configurar la clave de cifrado del servidor para poder guardar credenciales.</p> : null}
          {error ? <p className="text-sm text-red-600">{error}</p> : null}{message ? <p className="text-sm text-emerald-700">{message}</p> : null}
          <div className="flex justify-end"><button type="submit" className="inline-flex items-center justify-center rounded-xl bg-[rgb(var(--brand))] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:brightness-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" disabled={saving || !status?.encryptionReady}>{saving ? 'Guardando…' : status?.configured ? 'Reemplazar credenciales' : 'Guardar credenciales'}</button></div>
        </form>
      </>}
    </section>
  </div>;
}

function Field({ label, children }) { return <label className="grid gap-1 text-sm font-medium text-[rgb(var(--fg))]"><span>{label}</span>{children}</label>; }
